import React, { useState, useEffect, useRef } from 'react';
import { Main, Axios, Swal } from '../Helpers/importacionesComunes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faSignInAlt, faCircle, faPortrait, faUser } from '@fortawesome/free-solid-svg-icons';
import { useContextoGlobal } from '../Context/contextoGlobal';
import useRangosAsamblea from '../hooks/useRangosAsamblea';
import Ventana from '../componentes/Ventana';
import LogAsambleaRegistros from '../componentes/LogAsambleaRegistros';
import { Button, Card, Input, Spinner, Typography, IconButton, Tooltip } from '@material-tailwind/react';
import { IdentificationIcon, UserGroupIcon, UserIcon } from '@heroicons/react/24/solid';
import { InformationCircleIcon, MagnifyingGlassIcon, XCircleIcon, AdjustmentsHorizontalIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import ExportToExcelAsamblea from '../componentes/exportExcelAsamblea';

export default function AsambleaPresentes({ id_asamblea, finalizarAltaOcopia, nombre }) {
    const [huboError, setHuboError] = useState(false);
    const [datos, setDatos] = useState([]);
    const [rangos, setRangos] = useState([]);
    const [regiones, setRegiones] = useState([]);
    const [buscando, setBuscando] = useState(false);
    const [texto, setTexto] = useState('');
    const [regSeleccionadas, setRegSeleccionadas] = useState([]);
    const [rangosSeleccionados, setRangosSeleccionados] = useState([]);
    const [statusSeleccionados, setStatusSeleccionados] = useState([]);
    const [sexoSeleccionados, setSexoSeleccionados] = useState([]);
    const { conexionWebSocket, usuario, esCelular } = useContextoGlobal();
    const [mensaje, setMensaje] = useState('');
    const [orden, setOrden] = useState('f_ingreso');
    const [ab, setAb] = useState(true);
    const [qr, setQr] = useState(null);
    const { rangosAsamblea, buscarRangos, buscandoRangos } = useRangosAsamblea();
    const [logs, setLogs] = useState(false);
    const [registros, setRegistros] = useState([]);
    const todos = useRef(false);
    const [filas, setFilas] = useState(20);
    const [modoCompleto, setModoCompleto] = useState(true);

    // --- Efectos y Lógica de Datos ---
    // useEffect(() => {
    //     conexionWebSocket.on('mensaje_nuevo_registrado', data => {
    //         if (data.id_asamblea == id_asamblea) {
    //             setMensaje(data.mensaje);
    //             setTimeout(() => setMensaje(''), 800);
    //             buscarPresentes();
    //         }
    //     });
    //     conexionWebSocket.on('mensaje_modificacion_registrado', data => {
    //         if (data.id_asamblea == id_asamblea) {
    //             setMensaje(data.mensaje);
    //             setTimeout(() => setMensaje(''), 800);
    //             buscarPresentes();
    //         }
    //     });
    // }, []);

useEffect(() => {
    const handleNuevo = data => {
        if (data.id_asamblea == id_asamblea) {
            setMensaje(data.mensaje);
            setTimeout(() => setMensaje(''), 800);
            buscarPresentes();
        }
    };

    const handleModif = data => {
        if (data.id_asamblea == id_asamblea) {
            setMensaje(data.mensaje);
            setTimeout(() => setMensaje(''), 800);
            buscarPresentes();
        }
    };

    conexionWebSocket.on('mensaje_nuevo_registrado', handleNuevo);
    conexionWebSocket.on('mensaje_modificacion_registrado', handleModif);

    return () => {
        conexionWebSocket.off('mensaje_nuevo_registrado', handleNuevo);
        conexionWebSocket.off('mensaje_modificacion_registrado', handleModif);
    };
}, [id_asamblea]);

    useEffect(() => { buscarRangos(id_asamblea); }, []);

    useEffect(() => {
        if (rangosAsamblea.length > 0) {
            setBuscando(true);
            buscarTablasGenerales().then(() => buscarPresentes());
        }
    }, [rangosAsamblea]);

    const buscarPresentes = async () => {
        try {
            const { data } = await Axios.get(`/api/tablasgenerales/asambleapresentes/${id_asamblea}`);
            if (data.length === 0) {
                finalizarAltaOcopia();
                informarNoHayPresentes(nombre);
            }
            setDatos(data);
            setBuscando(false);
        } catch (err) {
            setBuscando(false);
            setHuboError(true);
        }
    };

    const buscarTablasGenerales = async () => {
        try {
            const vectorResultados = await Promise.all([Axios.get('/api/tablasgenerales/rangos'), Axios.get('/api/tablasgenerales/regiones/*')]);
            setRangos(vectorResultados[0].data.filter(item => rangosAsamblea.some(rango => item.id_rango == rango)));
            setRegiones(vectorResultados[1].data);
        } catch (err) {
            setHuboError(true);
        }
    };

    // --- Filtros ---
    const filtroRango = (id) => setRangosSeleccionados(prev => prev.includes(id) ? prev.filter(r => r !== id) : [...prev, id]);
    const filtroRegion = (id) => setRegSeleccionadas(prev => prev.includes(id) ? prev.filter(r => r !== id) : [...prev, id]);
    const filtroSexo = (id) => setSexoSeleccionados(prev => prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]);
    const filtroStatus = (id) => setStatusSeleccionados(prev => prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]);

    const handleOrden = (campo) => {
        if (campo === orden) { setAb(!ab); } 
        else { setAb(true); setOrden(campo); }
    };

    const listarLogs = async (id_presente) => {
        todos.current = false;
        try {
            const { data } = await Axios.get(`api/tablasgenerales/asamblea/logs/${id_asamblea}/${id_presente}`);
            setRegistros(data);
            setLogs(true);
        } catch (err) { alert(err); }
    };

    const listarAllLogs = async () => {
        todos.current = true;
        try {
            const { data } = await Axios.get(`api/tablasgenerales/asamblea/logs/${id_asamblea}/*`);
            setRegistros(data);
            setLogs(true);
        } catch (err) { alert(err); }
    };

    const iniciarRetiro = (presente) => {
        Swal.fire({
            text: `¿Confirma el retiro de ${presente.nombre}?`,
            showCancelButton: true,
            confirmButtonText: 'Si, retirar',
            cancelButtonText: 'Cancelar'
        }).then(res => { if (res.value) retirarPresente(presente.id_asamblea_presente, presente.id_obrero != null, presente.nombre); });
    };

    const iniciarReingreso = (presente) => {
        Swal.fire({
            text: `¿Confirma el reingreso de ${presente.nombre}?`,
            showCancelButton: true,
            confirmButtonText: 'Si, reingresar',
            cancelButtonText: 'Cancelar'
        }).then(res => { if (res.value) reingresarPresente(presente.id_asamblea_presente, presente.id_obrero != null, presente.nombre); });
    };

    const retirarPresente = async (id, ministro, nom) => {
        try {
            const url = ministro ? `/api/tablasgenerales/asambleapresente/${id}` : `/api/tablasgenerales/asambleadelegado/${id}`;
            await Axios.put(url, { id_asamblea, id_usuario: usuario.id_usuario, retirar: 1, nombre: nom });
            Swal.fire({ icon: 'success', text: `Retiro exitoso`, showConfirmButton: false, timer: 1500 });
        } catch (err) { Swal.fire({ icon: 'error', text: err.response.data.message }); }
    };

    const reingresarPresente = async (id, ministro, nom) => {
        try {
            const url = ministro ? `/api/tablasgenerales/asambleapresente/${id}` : `/api/tablasgenerales/asambleadelegado/${id}`;
            await Axios.put(url, { id_asamblea, id_usuario: usuario.id_usuario, retirar: 0, nombre: nom });
            Swal.fire({ icon: 'success', text: `Reingreso exitoso`, showConfirmButton: false, timer: 1500 });
        } catch (err) { Swal.fire({ icon: 'error', text: err.response.data.message }); }
    };

    // --- Renderizado Condicional ---
    if (huboError) return <Main center><span>Error al cargar los datos</span></Main>;
    if (buscando || buscandoRangos) return <Main center alinear><Spinner className="h-12 w-12" /></Main>;
    if (datos.length === 0) return null;

    // Filtrado de datos para el listado
    const datosFiltrados = datos.filter(callbackBusqueda(texto, regSeleccionadas, rangosSeleccionados, statusSeleccionados, sexoSeleccionados, qr));

    // return (
    //     <div className="w-full flex flex-col items-center p-0 md:p-4">
    //         {logs && <Ventana cerrar={() => setLogs(false)}>
    //             <LogAsambleaRegistros registros={registros} todos={todos.current} esCelular={esCelular} />
    //         </Ventana>}

    //         <div className="w-full flex flex-col md:flex-row justify-between items-center gap-4 mb-6 border-b pb-4">
    //             <Typography variant="h4" color="blue-gray">{nombre}</Typography>
    //             <div className="flex flex-wrap justify-center gap-2">
    //                 {!esCelular && <>
    //                     <Button variant="outlined" size="sm" onClick={() => setModoCompleto(!modoCompleto)} className="flex items-center gap-2">
    //                         <AdjustmentsHorizontalIcon className="h-4 w-4" /> {modoCompleto ? 'Ocultar Filtros' : 'Más Filtros'}
    //                     </Button>
    //                     <ExportToExcelAsamblea id_asamblea={id_asamblea} />
    //                 </>}
    //                 <Button variant="gradient" color="blue-gray" size="sm" onClick={listarAllLogs}>Logs de registros</Button>
    //             </div>
    //         </div>

    //         <EstadisticasAsamblea 
    //             datos={datos} mensaje={mensaje} esCelular={esCelular}
    //             statusSeleccionados={statusSeleccionados} sexoSeleccionados={sexoSeleccionados}
    //             filtroStatus={filtroStatus} filtroSexo={filtroSexo}
    //             es_status_seleccionado={es_status_seleccionado} es_sexo_seleccionado={es_sexo_seleccionado}
    //         />

    //         {modoCompleto && (
    //             <Card className="w-full mt-6 p-4 shadow-sm border border-gray-100">
    //                 <PanelFiltrosAsamblea 
    //                     rangos={rangos} regiones={regiones} datos={datos}
    //                     rangosSeleccionados={rangosSeleccionados} regSeleccionadas={regSeleccionadas}
    //                     filtroRango={filtroRango} filtroRegion={filtroRegion}
    //                     es_rango_seleccionado={es_rango_seleccionado} es_region_seleccionada={es_region_seleccionada}
    //                     esCelular={esCelular}
    //                 />
    //             </Card>
    //         )}

    //         <div className="w-full mt-8 flex flex-col gap-4">
    //             <div className="flex flex-col lg:flex-row justify-between items-center gap-4">
    //                 <div className="flex items-center gap-2 overflow-x-auto w-full pb-2 lg:pb-0">
    //                     <Typography variant="small" className="font-bold text-gray-400 uppercase">Ordenar:</Typography>
    //                     <Button variant="text" size="sm" onClick={() => handleOrden('nombre')}>Nombre</Button>
    //                     <Button variant="text" size="sm" onClick={() => handleOrden('f_ingreso')}>Ingreso</Button>
    //                 </div>
    //                 <div className="w-full lg:w-96">
    //                     <Input label="Buscar..." icon={<MagnifyingGlassIcon className="h-5 w-5" />} onChange={(e) => setTexto(e.target.value)} color="black" />
    //                 </div>
    //             </div>

    //             <div className="mt-4">
    //                 {esCelular ? (
    //                     <div className="grid grid-cols-1 gap-4">
    //                         {datosFiltrados.filter((_, i) => i <= filas).sort((a, b) => ordenar(a, b, ab, orden)).map(item => (
    //                             <MobileCardAsamblea key={item.id_asamblea_presente} item={item} iniciarRetiro={iniciarRetiro} iniciarReingreso={iniciarReingreso} listarLogs={listarLogs} />
    //                         ))}
    //                     </div>
    //                 ) : (
    //                     <Card className="overflow-hidden border border-gray-200">
    //                         <table className="w-full table-auto text-left">
    //                             <thead className="bg-blue-gray-50/50">
    //                                 <tr>
    //                                     {["Estado", "Nombre / Delegación", "Región", "Ingreso", "Egreso", "Acciones"].map(h => (
    //                                         <th key={h} className="p-4 border-b border-blue-gray-100 font-bold uppercase text-[10px] text-blue-gray-400">{h}</th>
    //                                     ))}
    //                                 </tr>
    //                             </thead>
    //                             <tbody>
    //                                 {datosFiltrados.filter((_, i) => i <= filas).sort((a, b) => ordenar(a, b, ab, orden)).map((item, index) => (
    //                                     <DesktopRowAsamblea key={item.id_asamblea_presente} item={item} iniciarRetiro={iniciarRetiro} iniciarReingreso={iniciarReingreso} listarLogs={listarLogs} />
    //                                 ))}
    //                             </tbody>
    //                         </table>
    //                     </Card>
    //                 )}
    //             </div>
    //             <div className="flex justify-center mt-6">
    //                 <Button variant="text" color="blue" className="flex items-center gap-2" onClick={() => setFilas(filas + 10)}>
    //                     Mostrar más <ArrowRightIcon className="h-4 w-4" />
    //                 </Button>
    //             </div>
    //         </div>
    //     </div>
    // );
return (
        <div className="w-full flex flex-col items-center p-0 md:p-4">
            {logs && <Ventana cerrar={() => setLogs(false)}>
                <LogAsambleaRegistros registros={registros} todos={todos.current} esCelular={esCelular} />
            </Ventana>}

            <div className="w-full max-w-6xl flex flex-col items-center">
                {/* ENCABEZADO */}
                <div className="w-full flex flex-col md:flex-row justify-between items-center gap-4 mb-6 border-b pb-4">
                    <Typography variant="h4" color="blue-gray" className="uppercase font-black">{nombre}</Typography>
                    <div className="flex flex-wrap justify-center gap-2">
                        {!esCelular && <>
                            <Button variant="outlined" size="sm" onClick={() => setModoCompleto(!modoCompleto)} className="flex items-center gap-2">
                                <AdjustmentsHorizontalIcon className="h-4 w-4" /> {modoCompleto ? 'Ocultar Filtros' : 'Más Filtros'}
                            </Button>
                            <ExportToExcelAsamblea id_asamblea={id_asamblea} />
                        </>}
                        <Button variant="gradient" color="blue-gray" size="sm" onClick={listarAllLogs}>Logs de registros</Button>
                    </div>
                </div>
                <Puestos id_asamblea={id_asamblea}/>
                {/* ESTADÍSTICAS */}
                <EstadisticasAsamblea 
                    datos={datos} mensaje={mensaje} esCelular={esCelular}
                    statusSeleccionados={statusSeleccionados} sexoSeleccionados={sexoSeleccionados}
                    filtroStatus={filtroStatus} filtroSexo={filtroSexo}
                    es_status_seleccionado={es_status_seleccionado} es_sexo_seleccionado={es_sexo_seleccionado}
                />

                {/* PANEL DE FILTROS */}
                {modoCompleto && (
                    <Card className="w-full mt-6 p-4 shadow-sm border border-gray-100">
                        <PanelFiltrosAsamblea 
                            rangos={rangos} regiones={regiones} datos={datos}
                            rangosSeleccionados={rangosSeleccionados} regSeleccionadas={regSeleccionadas}
                            filtroRango={filtroRango} filtroRegion={filtroRegion}
                            es_rango_seleccionado={es_rango_seleccionado} es_region_seleccionada={es_region_seleccionada}
                            esCelular={esCelular}
                        />
                    </Card>
                )}

                {/* ORDENAMIENTO Y BUSQUEDA */}
                <div className="w-full mt-8 flex flex-col lg:flex-row justify-between items-center gap-4">
                    <div className="flex items-center gap-2 overflow-x-auto w-full pb-2 lg:pb-0">
                        <Typography variant="small" className="font-bold text-gray-400 uppercase">Ordenar:</Typography>
                        <Button variant="text" size="sm" onClick={() => handleOrden('nombre')}>Nombre</Button>
                        <Button variant="text" size="sm" onClick={() => handleOrden('f_ingreso')}>Ingreso</Button>
                    </div>
                    <div className="w-full lg:w-96">
                        <Input label="Buscar por nombre o DNI..." icon={<MagnifyingGlassIcon className="h-5 w-5" />} onChange={(e) => setTexto(e.target.value)} color="black" />
                    </div>
                </div>
            </div>

            {/* SECCIÓN DE TABLA: Esta SI ocupa el w-full sin límites adicionales */}
            <div className="w-full mt-6">
                {esCelular ? (
                    <div className="grid grid-cols-1 gap-4 px-2">
                        {datosFiltrados.filter((_, i) => i <= filas).sort((a, b) => ordenar(a, b, ab, orden)).map(item => (
                            <MobileCardAsamblea key={item.id_asamblea_presente} item={item} iniciarRetiro={iniciarRetiro} iniciarReingreso={iniciarReingreso} listarLogs={listarLogs} />
                        ))}
                    </div>
                ) : (
                    <Card className="overflow-hidden border border-gray-200 rounded-none md:rounded-xl">
                        <table className="w-full table-auto text-left">
                            <thead className="bg-blue-gray-50/50">
                                <tr>
                                    {["Estado", "Nombre / Delegación", "Región", "Ingreso", "Egreso", "Acciones"].map(h => (
                                        <th key={h} className="p-4 border-b border-blue-gray-100 font-bold uppercase text-[10px] text-blue-gray-400 tracking-wider">
                                            {h}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {datosFiltrados.filter((_, i) => i <= filas).sort((a, b) => ordenar(a, b, ab, orden)).map((item, index) => (
                                    <DesktopRowAsamblea key={item.id_asamblea_presente} item={item} iniciarRetiro={iniciarRetiro} iniciarReingreso={iniciarReingreso} listarLogs={listarLogs} />
                                ))}
                            </tbody>
                        </table>
                    </Card>
                )}
                
                {/* BOTON MOSTRAR MAS */}
                <div className="flex justify-center mt-6 pb-10">
                    <Button variant="text" color="blue" className="flex items-center gap-2 font-black" onClick={() => setFilas(filas + 10)}>
                        Cargar más registros <ArrowRightIcon className="h-4 w-4" />
                    </Button>
                </div>
            </div>
        </div>
    );
}

// --- Funciones Auxiliares Fuera del Componente ---
function callbackBusqueda(texto, regiones, rangos, status, sexos, qr) {
    return p => ((p.nombre.toUpperCase().includes(texto.toUpperCase()) || p.delegado.toUpperCase().includes(texto.toUpperCase()) || Number(p.id_asamblea_presente) == Number(texto) || (Number(p.id_obrero) == Number(qr) && qr != null) || p.nro_documento.toString().includes(texto)) && (regiones.includes(p.id_region) || regiones.length == 0) && (rangos.includes(p.id_rango) || rangos.length == 0) && (status.includes(p.retirado) || status.length == 0) && (sexos.includes(p.sexo) || sexos.length == 0));
}

function es_status_seleccionado(status, id) { return status.includes(id) ? 'border-blue-500 bg-blue-50/30' : ''; }
function es_sexo_seleccionado(sexos, id) { return sexos.includes(id) ? 'border-blue-500 bg-blue-50/30' : ''; }
function es_rango_seleccionado(rangos, id) { return rangos.includes(id); }
function es_region_seleccionada(regiones, id) { return regiones.includes(id); }

function ordenar(a, b, ab, orden) {
    if (!a[orden] || !b[orden]) return 0;
    return ab ? a[orden].localeCompare(b[orden]) : b[orden].localeCompare(a[orden]);
}

function informarNoHayPresentes(nombre) { Swal.fire({ icon: 'warning', text: `No hay presentes en ${nombre}` }); }

// --- Sub-Componentes Internos ---
const MobileCardAsamblea = ({ item, iniciarRetiro, iniciarReingreso, listarLogs }) => (
    <Card className="p-4 border border-gray-100 shadow-sm">
        <div className="flex justify-between items-start mb-3">
            <div className="flex items-center gap-2">
                <div className={`h-3 w-3 rounded-full ${item.retirado == 0 ? 'bg-green-500' : 'bg-red-500 shadow-md'}`} />
                <Typography variant="small" className="font-bold text-gray-500 uppercase text-[10px]">
                    {item.id_iglesia ? "Delegado" : `Ministro ${item.rango}`}
                </Typography>
            </div>
            <span className="bg-blue-gray-700 text-white text-[10px] font-bold px-2 py-0.5 rounded">R-{item.id_region}</span>
        </div>
        <Typography variant="h6" color="blue-gray" className="mb-0.5 uppercase leading-tight">{item.nombre}</Typography>
        <Typography variant="small" className="text-gray-500 mb-3 italic text-[11px]">{item.id_iglesia ? item.delegado : 'Credencial Ministro'}</Typography>
        <div className="grid grid-cols-2 gap-2 bg-gray-50 p-2 rounded-lg mb-4">
            <div className="flex flex-col"><span className="text-[9px] uppercase font-bold text-gray-400">Ingreso</span><span className="text-sm font-bold text-blue-gray-800">{item.f_ingreso.slice(10)}</span></div>
            {item.f_egreso && <div className="flex flex-col border-l pl-2"><span className="text-[9px] uppercase font-bold text-gray-400">Egreso</span><span className="text-sm font-bold text-red-500">{item.f_egreso.slice(10)}</span></div>}
        </div>
        <div className="flex gap-2">
            {item.retirado == 0 ? <Button fullWidth size="sm" color="red" variant="gradient" onClick={() => iniciarRetiro(item)}>Retirar</Button> : <Button fullWidth size="sm" color="green" variant="gradient" onClick={() => iniciarReingreso(item)}>Reingresar</Button>}
            <IconButton size="sm" color="blue-gray" variant="text" onClick={() => listarLogs(item.id_asamblea_presente)}><InformationCircleIcon className="h-5 w-5" /></IconButton>
        </div>
    </Card>
);

const DesktopRowAsamblea = ({ item, iniciarRetiro, iniciarReingreso, listarLogs }) => {
    const classes = "p-4 border-b border-blue-gray-50";
    return (
        <tr className="hover:bg-blue-gray-50/50 transition-colors">
            <td className={classes}><div className="flex items-center gap-2"><div className={`h-3 w-3 rounded-full ${item.retirado == 0 ? 'bg-green-500' : 'bg-red-500'}`} /><Typography variant="small" className="font-bold text-blue-gray-400">{item.id_iglesia ? "DELEGADO" : "MINISTRO"}</Typography></div></td>
            <td className={classes}><Typography variant="small" color="blue-gray" className="font-bold uppercase">{item.nombre}</Typography><Typography variant="small" className="text-[11px] text-gray-500 italic">{item.id_iglesia ? item.delegado : item.rango}</Typography></td>
            <td className={classes}><Typography variant="small" className="font-bold">R-{item.id_region}</Typography></td>
            <td className={classes}><Typography variant="small" className="text-green-700 font-bold">{item.f_ingreso.slice(10)}</Typography><Typography className="text-[10px] text-gray-400">{item.usuario_alta}</Typography></td>
            <td className={classes}>{item.f_egreso ? <><Typography variant="small" className="text-red-700 font-bold">{item.f_egreso.slice(10)}</Typography><Typography className="text-[10px] text-gray-400">{item.usuario_baja}</Typography></> : "--:--"}</td>
            <td className={classes}><div className="flex items-center gap-2">{item.retirado == 0 ? <Button size="sm" color="red" variant="text" onClick={() => iniciarRetiro(item)}>Retirar</Button> : <Button size="sm" color="green" variant="text" onClick={() => iniciarReingreso(item)}>Reingresar</Button>}<IconButton size="sm" variant="text" onClick={() => listarLogs(item.id_asamblea_presente)}><InformationCircleIcon className="h-5 w-5" /></IconButton></div></td>
        </tr>
    );
};

export const PanelFiltrosAsamblea = ({ rangos, regiones, datos, rangosSeleccionados, regSeleccionadas, filtroRango, filtroRegion, es_rango_seleccionado, es_region_seleccionada, esCelular }) => (
    <div className="flex flex-col items-center w-full mt-2">
        <div className="flex items-center gap-2 mb-6"><InformationCircleIcon className="h-5 w-5 text-blue-gray-400" /><Typography variant="h6" color="blue-gray">Detalles de Búsqueda</Typography></div>
        <div className="w-full flex flex-wrap justify-center gap-4 mb-8">
            {rangos.map(r => (
                <div key={r.id_rango} onClick={() => filtroRango(r.id_rango)} className={`relative flex flex-col items-center min-w-[120px] p-3 rounded-xl border-2 transition-all cursor-pointer ${es_rango_seleccionado(rangosSeleccionados, r.id_rango) ? "bg-blue-500 border-blue-600 text-white" : "bg-white border-gray-100 hover:border-blue-200"}`}>
                    <Typography variant="small" className="font-bold leading-tight">{r.iniciales}</Typography>
                    <Typography className="text-[9px] uppercase font-semibold">{r.nombre.substring(2)}</Typography>
                    <div className={`absolute -top-2 -right-2 min-w-[22px] h-5 px-1.5 flex items-center justify-center rounded-full text-[10px] font-black ${es_rango_seleccionado(rangosSeleccionados, r.id_rango) ? "bg-white text-blue-600" : "bg-blue-gray-800 text-white"}`}>{datos.filter(p => p.id_rango === r.id_rango).length}</div>
                </div>
            ))}
        </div>
        <div className={`grid gap-3 w-full border-t pt-6 ${esCelular ? "grid-cols-3" : "grid-cols-5 md:grid-cols-10"}`}>
            {regiones.map(reg => (
                <button key={reg.id_region} onClick={() => filtroRegion(reg.id_region)} className={`flex flex-col items-center p-3 rounded-xl border-2 transition-all ${es_region_seleccionada(regSeleccionadas, reg.id_region) ? "bg-black border-black text-white shadow-xl scale-105" : "bg-white border-blue-gray-50 text-gray-700"}`}>
                    <span className="font-black text-[14px]">R-{reg.id_region}</span>
                    <span className="text-[11px]">({datos.filter(p => p.id_region === reg.id_region).length})</span>
                </button>
            ))}
        </div>
    </div>
);

export const EstadisticasAsamblea = ({ datos, mensaje, esCelular, statusSeleccionados, sexoSeleccionados, filtroStatus, filtroSexo, es_status_seleccionado, es_sexo_seleccionado }) => {
    const cards = [
        { id: 'reg', titulo: 'Registrados', valor: datos.length, icon: <IdentificationIcon className="h-6 w-6 text-blue-gray-500" /> },
        { id: 'pres', titulo: 'Presentes', valor: datos.filter(p => p.retirado == 0).length, icon: <div className="h-3 w-3 rounded-full bg-green-500 shadow-md" />, onClick: () => filtroStatus(0), activo: es_status_seleccionado(statusSeleccionados, 0) },
        { id: 'ret', titulo: 'Retirados', valor: datos.filter(p => p.retirado == 1).length, icon: <div className="h-3 w-3 rounded-full bg-red-500 shadow-md" />, onClick: () => filtroStatus(1), activo: es_status_seleccionado(statusSeleccionados, 1) },
        { id: 'hom', titulo: 'Hombres', valor: datos.filter(p => p.sexo === "M").length, icon: <UserIcon className="h-5 w-5 text-blue-500" />, onClick: () => filtroSexo('M'), activo: es_sexo_seleccionado(sexoSeleccionados, 'M') },
        { id: 'muj', titulo: 'Mujeres', valor: datos.filter(p => p.sexo === "F").length, icon: <UserIcon className="h-5 w-5 text-pink-500" />, onClick: () => filtroSexo('F'), activo: es_sexo_seleccionado(sexoSeleccionados, 'F') },
        { id: 'del', titulo: 'Delegados', valor: datos.filter(p => p.sexo === "D").length, icon: <UserGroupIcon className="h-5 w-5 text-orange-500" />, onClick: () => filtroSexo('D'), activo: es_sexo_seleccionado(sexoSeleccionados, 'D') }
    ];
    return (
        <div className="w-full mt-2">
            {mensaje && <div className="mb-4 p-3 bg-red-50 rounded-lg border border-red-100 animate-pulse"><Typography color="red" className="text-center font-bold">{mensaje}</Typography></div>}
            <div className={`grid gap-4 ${esCelular ? 'grid-cols-2' : 'grid-cols-2 md:grid-cols-3 lg:grid-cols-6'}`}>
                {cards.map(c => (
                    <Card key={c.id} onClick={c.onClick} className={`p-4 flex flex-col items-center justify-center border-2 transition-all ${c.onClick ? 'cursor-pointer' : ''} ${c.activo}`}>
                        <div className="mb-2">{c.icon}</div>
                        <Typography variant="small" className="font-medium text-blue-gray-400 uppercase text-[10px]">{c.titulo}</Typography>
                        <Typography variant="h4" color="blue-gray" className="font-black mt-1">{c.valor}</Typography>
                    </Card>
                ))}
            </div>
        </div>
    );
};

const Puestos = ({ id_asamblea }) => {
    const { conexionWebSocket } = useContextoGlobal();
    const [puestos, setPuestos] = useState({});

   const buscarPuestos = async () => {
        try {
            const { data } = await Axios.get(`/api/tablasgenerales/asamblea-puestos/${id_asamblea}`);
           
            const puestos_bd = {};

            data.map(i=>{
                puestos_bd[i.usuario_alta] = i.ingresados;
            })

            setPuestos(puestos_bd);
           
        } catch (err) {
            console.log(err)
        }
    };

    useEffect(() => {
        
        buscarPuestos();

        const handler = (data) => {
            if (data.id_asamblea == id_asamblea) {
                // Usamos la función prev para no depender de la variable externa puestos
                setPuestos(prev => ({
                    ...prev,
                    [data.usuario]: prev[data.usuario] ? prev[data.usuario] + 1 : 1,
                }));
            }
        };

        conexionWebSocket.on('asamblea_puestos', handler);

        // LIMPIEZA: Apagamos el socket cuando el componente se destruye
        return () => {
            conexionWebSocket.off('asamblea_puestos', handler);
        };


    }, [id_asamblea]); // Si cambia el id, reiniciamos suscripción

return (
    <div className='mb-4 mt-4'>
        <Typography className='text-center' variant="h6" color="blue-gray">Puestos de ingreso habilitados</Typography>
        <div className="flex gap-2 p-2 bg-gray-100 rounded">
            {Object.keys(puestos).map(u => {
                return (
                    <div key={u} className="flex flex-col items-center"> 
                        <span className="text-xs bg-blue-500 text-white px-2 py-1 rounded-full">
                            {u}
                        </span>
                        <p title='Cantidad de ingresados en el puesto'>{puestos[u]}</p>
                    </div>
                );
            })}
        </div>
    </div>

);
};